import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div className="d-flex justify-content-center mt-5 text-center">
      <section>
        <h1>Page Not Found</h1>
        <br />
        <p className="fs-5">Page Does Not Exist</p>
        <div>
          <button className="btn btn-secondary" onClick={goBack}>
            Go Back
          </button>
        </div>
      </section>
    </div>
  );
};

export default PageNotFound;
